/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_CopyInputs */

const en_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const fr_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const de_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopie`)
};

const it_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const ru_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копия`)
};

const es_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const zh_cn2_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

const ja_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

const hi_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_context_menu_copy = /** @type {(inputs: Context_Menu_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cópia`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Context_Menu_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_copy = /** @type {((inputs?: Context_Menu_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_copy(inputs)
	if (locale === "de") return de_context_menu_copy(inputs)
	if (locale === "it") return it_context_menu_copy(inputs)
	if (locale === "ru") return ru_context_menu_copy(inputs)
	if (locale === "es") return es_context_menu_copy(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_copy(inputs)
	if (locale === "ja") return ja_context_menu_copy(inputs)
	if (locale === "hi") return hi_context_menu_copy(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_copy(inputs)
	return en_context_menu_copy(inputs)
});